import { render, staticRenderFns } from "./AppCustomPaginationComponent.vue?vue&type=template&id=ae6ea954&scoped=true"
import script from "./AppCustomPaginationComponent.vue?vue&type=script&lang=js"
export * from "./AppCustomPaginationComponent.vue?vue&type=script&lang=js"
import style0 from "./AppCustomPaginationComponent.vue?vue&type=style&index=0&id=ae6ea954&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae6ea954",
  null
  
)

export default component.exports